
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import * as XLSX from 'xlsx';

import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';

import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';

import { SummaryDepositModel } from '@/models/summary-deposit';
import { DepositModel } from '@/models/deposit';

import ListDeposit from './components/ListDeposit.vue';
import FilterBox from './components/FilterBox.vue';

import depositServices from '@/services/deposit-services';
import SummaryOrder from './components/SummaryOrder.vue';
import commonService from '@/services/common-services';
@Component({
    components: {
        ListDeposit,
        FilterBox,
        Loading,
        Paging,
        SummaryOrder
    }
})
export default class MainDeposit extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };
    
    private summaryOrder: SummaryDepositModel = new SummaryDepositModel();
    private listDeposit: DepositModel[] = [];
    private isLoading = false;
    private chinaAddress = null;
    private showImportDialog = false;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    private async getConfig() {
      const result = await commonService.configuration();
      if (result && result.status === 200) {
        this.chinaAddress = result.data.data.ChinaStoreAddress;
      }
    }

    private async created() {
        this.loadData();
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryDepositModel();
        this.getConfig();
        const result = await depositServices.getDeposit(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListDeposit: DepositModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus7: result.data.summary.TotalStatus7 || 0,
                TotalStatus8: result.data.summary.TotalStatus8 || 0,
                TotalStatus9: result.data.summary.TotalStatus9 || 0,
                TotalStatus10: result.data.summary.TotalStatus10 || 0,
                TotalStatus16: result.data.summary.TotalStatus16 || 0,
            };

            for (const item of result.data.data) {
                const deposit = new DepositModel();
                deposit.id = item.ID;
                deposit.depositCode = item.DepositCode;
                deposit.orderTransactionCode = item.OrderTransactionCode;
                deposit.uId = item.UID;
                deposit.userName = item.Username;
                deposit.status = item.Status;
                deposit.statusDetail = DATA.depositStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                deposit.orderWeight = item.OrderWeight;
                deposit.totalPriceVND = item.TotalPriceVND;
                deposit.createdDate = item.CreatedDate;

                tmpListDeposit.push(deposit);
            }
            this.listDeposit = tmpListDeposit;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'DepositCode',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private createNewDeposit() {
        const routeData = this.$router.resolve({ name: 'deposit-new' });
        window.open(routeData.href, '_blank');
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }

    private openFileDialog() {
        this.showImportDialog = true;
    }

    private closeImportDialog() {
        this.showImportDialog = false;
    }

    private selectFile() {
        this.showImportDialog = false;
        this.$nextTick(() => {
            const fileInput = this.$refs.fileInput as HTMLInputElement;
            if (fileInput) {
                fileInput.click();
            }
        });
    }

    private async handleFileUpload(event: any) {
        const file = event.target.files[0];
        if (!file) {
            return;
        }

        try {
            this.isLoading = true;
            const data = await this.readExcelFile(file);
            const trackingCodes = this.parseExcelData(data);
            
            if (trackingCodes.length === 0) {
                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: 'Lỗi',
                    text: 'File Excel không có dữ liệu hợp lệ!'
                });
                this.isLoading = false;
                return;
            }

            await this.createDepositsFromExcel(trackingCodes);
            
            // Reset file input
            (event.target as HTMLInputElement).value = '';
        } catch (error) {
            // console.error('Error processing file:', error);
            this.$notify({
                group: 'notify',
                type: 'error',
                title: 'Lỗi',
                text: 'Có lỗi xảy ra khi xử lý file Excel!'
            });
            this.isLoading = false;
        }
    }

    private readExcelFile(file: File): Promise<any[]> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                    resolve(jsonData);
                } catch (error) {
                    reject(error);
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(file);
        });
    }

    private parseExcelData(data: any[]): string[] {
        const trackingCodes: string[] = [];
        
        // Bỏ qua dòng header (dòng đầu tiên)
        for (let i = 1; i < data.length; i++) {
            const row = data[i];
            if (row && row[0]) {
                const code = String(row[0]).trim();
                if (code && code.length > 0) {
                    trackingCodes.push(code);
                }
            }
        }
        
        return trackingCodes;
    }

    private async createDepositsFromExcel(trackingCodes: string[]) {
        try {
            const result = await depositServices.bulkImportDeposits(trackingCodes);
            
            this.isLoading = false;
            
            if (result && result.data && result.data.status === 200) {
                const { totalSuccess, totalError, errors } = result.data.data;
                
                // Hiển thị kết quả thành công
                if (totalSuccess > 0) {
                    this.$notify({
                        group: 'notify',
                        type: 'success',
                        title: 'Thành công',
                        text: `Đã tạo thành công ${totalSuccess} đơn ký gửi!`
                    });
                }
                
                // Hiển thị lỗi nếu có
                if (totalError > 0 && errors.length > 0) {
                    const errorMessages = errors.map((e: any) => `${e.code}: ${e.reason}`);
                    const errorMessage = errorMessages.length > 3 
                        ? errorMessages.slice(0, 3).join('\n') + `\n... và ${totalError - 3} lỗi khác`
                        : errorMessages.join('\n');
                    
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: `Có ${totalError} đơn bị lỗi`,
                        text: errorMessage,
                        duration: 10000
                    });
                }
            } else {
                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: 'Lỗi',
                    text: result.data ? result.data.reason : 'Có lỗi xảy ra khi tạo đơn ký gửi!'
                });
            }
            
            // Reload danh sách
            this.loadData();
        } catch (error: any) {
            this.isLoading = false;
            this.$notify({
                group: 'notify',
                type: 'error',
                title: 'Lỗi',
                text: error.message || 'Có lỗi xảy ra khi tạo đơn ký gửi!'
            });
        }
    }
}
